<template>
	<div class="hello">
		<div class="row shop">
			<!-- 设置一个动态的高度溢出时自动显示滚动条 -->
			<div class="col-lg-12  col-md-12 table-responsive" :style="{'overflow-x': 'auto','overflow-y':'hidden',height:offset_height+'px'}"  >
				<div>
					<table>
						<div>
							<table class="t-table text-nowrap ">
								<!-- 表格头部 -->
								<!-- 将表头固定 translateY的优先层级最高当高度超出时出现滚动条滚动时表头一直计算滚动的高度所以内容数据一直往上滚动而表头固定-->
								<thead class="thead">
									<tr class="thb">
										<!-- <th v-show="fields"><div class="fixed">#</div></th> -->
										<!-- <th v-show="fields"><div class="fixed"><input type="checkbox" v-model="btn_check" @change="tr_flag && btn_check_cli()"></div></th> -->
										<th  ><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器名称</div></th>
                                        <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器ID</div></th>
                                        <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >开服时间</div></th>
                                        <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >是否为推荐</div></th>
                                        <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >目前在线人数</div></th>
                                        <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >排队人数</div></th>
                                        <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >当前状态</div></th>

										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器名</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >内部名</div></th> -->
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >当前注册人数</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >是否为测试服</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >是否为新服</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >是否允许推荐</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >是否可创建角色</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >对外开关</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器分组</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器对应地区</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器配置时间</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器对外时间</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >最近一次启动时间</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >最近一次修改时间</div></th>
										<th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >实例名称</div></th>
										<!-- <th v-show="(count-child_index_page+num+1)>child_index_total" style="width:16px"></th> -->
									</tr>
								</thead>
							</table>
						</div>
						<!-- 表格数据 -->
						<div :style="{height:(offset_height-78)+'px','overflow-y': 'auto','overflow-x':'hidden'}">
							<table class="t-table text-nowrap ">
								<tbody id="tbody" >
									<!-- 新建的列表数据   当有多个循环的时候key值不能重复-->
									<!-- <tr v-for="(num,index1) in num" :key="index1" :class="{list_color:true}" style="margin-top: 0;  align-self:flex-end">
										<td ><div class="fixed">{{index1+child_index_page}}</div></td>
										<td ><div class="fixed"><input type="checkbox" v-model="add_checkeds" :value="index1" ></div></td>
										<td class="fixed-list" v-for="(le,index) in len" :key="index">	
											 输入框根据索引显示内容当添加新项目时会把之前的索引添加到现有的索引中所以会把输入框的内容添加到新的项目中 :id="'fld'+index"-->
											<!-- <div class="input-width" :style="{width:th_width[index]+'px'}">
												<input  v-if="le.check_show" type="checkbox" v-model="check[index1+'-'+index]">
												<input style="width:100%" v-if="le.input_show" type="text" v-model="msg[index1+'-'+index]">
												<input style="width:100%" v-if="le.textarea_show" type="text" v-model="msg[index1+'-'+index]">
												<input style="width:100%" v-if="le.password_show" type="text" v-model="msg[index1+'-'+index]">
												<input style="width:100%" v-if="le.date_time_show" type="text" v-model="msg[index1+'-'+index]"> -->
												<!-- 滑动开关 -->
												<!-- <div > -->
													<!-- <div class="onoffswitch" v-if="le.on_off_show">
														<input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" 
														:id="'myonoffswitch'+index1+'-'+index" v-model="msg_onoff[index1+'-'+index]" >
     													<label class="onoffswitch-label" :for="'myonoffswitch'+index1+'-'+index">
     													    <span class="onoffswitch-inner"></span>
     													    <span class="onoffswitch-switch"></span>
     													</label>
													</div> -->
												<!-- </div> -->
												
												<!-- <span style="width:20%" v-if="le.span_show" @click="serch(index1,index,undefined,$event)" class="serch_box">
													<i class="fa fa-ellipsis-h fa-1x"></i>
												</span>
											</div>
										</td>
									</tr>										 --> 
									<!-- 初始请求的列表数据 -->
									<!-- 编辑时把数据填充到输入框中 加上item是为了避免key值的和上一个tr的key值重复-->
									<tr v-for="(list,index) in list_data" :key="index">
										<!-- {{item}} -->
										<!-- <td ><div class="fixed">{{index+1+child_index}}</div></td> -->
										<!-- 给每个复选框绑定不一样的v-model -->
										<!-- <td ><div class="fixed"><input type="checkbox" :disabled="V_disabled" v-model="btn_checkeds" :value="index"></div></td> -->
										<!-- 渲染多个tr project为对象的每一项-->										
										<td class="fixed-list " :title="list.fld_server_name">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_server_name}}
											</div>
										</td>
                                        <td class="fixed-list " :title="list.fld_server_id">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_server_id}}
											</div>
										</td>
                                        <td class="fixed-list " :title="list.fld_server_open">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_server_open}}
											</div>
										</td>
                                        <td class="fixed-list " :title="list.fld_is_recom">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_is_recom}}
											</div>
										</td>
                                        <td class="fixed-list " :title="list.fld_online_user">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_online_user}}
											</div>
										</td>
                                        <td class="fixed-list " :title="list.fld_lineup_user">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_lineup_user}}
											</div>
										</td>
                                        <td class="fixed-list " :title="list.fld_ishealthy">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_ishealthy}}
											</div>
										</td>



										<!-- <td class="fixed-list " :title="list.fld_open_time">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_open_time}}
											</div>
										</td> -->
										<td class="fixed-list " :title="list.fld_register">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_register}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_is_test">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_is_test}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_isnew">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_isnew}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_isallow_recom">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_isallow_recom}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_iscreate_role">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_iscreate_role}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_isopen">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_isopen}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_group_name">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_group_name}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_region">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_region}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_conf_time">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_conf_time}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_open_time">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_open_time}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_restart_time">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_restart_time}}
											</div>
										</td>
										<td class="fixed-list " :title="list.fld_modif_time">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.fld_modif_time}}
											</div>
										</td>
										<td class="fixed-list " :title="list.example_id">
											<div style="text-overflow: ellipsis;overflow: hidden; width:150px" >
                                                {{list.example_id}}
											</div>
										</td>

										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >内部名</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >当前注册人数</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >是否为测试服</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >是否为新服</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >是否允许推荐</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >是否可创建角色</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >对外开关</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器分组</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器对应地区</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器配置时间</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >服务器对外时间</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >最近一次启动时间</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >最近一次修改时间</div></th> -->
										<!-- <th><div style="width:150px;text-overflow: ellipsis;overflow: hidden;" >当前状态</div></th> -->



									</tr>																			
								</tbody>
							</table>
						</div>
					</table>
				</div>
			</div>
		</div>
	</div>	
</template>

<script>
import api from '../api/index.js';
export default {
  data () {
    return {
        //获取数据框的高度
		offset_height:null,
        list_data:null,
        timeOut:null,
    };
  },
    props:{
        sle_zone:String
    },
  components: {},
  watch: {
	  	// sle_zone:{
		// 	handler(newValue,oldValue){
		// 		console.log(newValue,this.list_data)
		// 		this.refresh_time_zone(this.list_data,newValue)
		// 	},
		// 	deep: true,
		// 	immediate: true
		// },
		sle_zone(newValue){
			// console.log(newValue)
			// if(this.list_data){
			// 	this.refresh_time_zone(this.list_data,newValue)
			// }
			this.get_data(newValue)
		}
  },
  computed: {},

  mounted(){
      this.get_data(this.sle_zone)
  },
  beforeDestroy(){
    //   alert(0)
      clearTimeout(this.timeOut);
  },
  methods: {
	  //计算时区时间
	datetime2zone_x(_date_time, _zone) {
				//定义utc时区字段
				const UTC_ZONE = {
				    "UTC-0000": -0 * 3600 * 1000,
				    "UTC-0100": -1 * 3600 * 1000,
				    "UTC-0200": -2 * 3600 * 1000,
				    "UTC-0300": -3 * 3600 * 1000,
				    "UTC-0400": -4 * 3600 * 1000,
				    "UTC-0500": -5 * 3600 * 1000,
				    "UTC-0600": -6 * 3600 * 1000,
				    "UTC-0700": -7 * 3600 * 1000,
				    "UTC-0800": -8 * 3600 * 1000,
				    "UTC-0900": -9 * 3600 * 1000,
				    "UTC-1000": -10 * 3600 * 1000,
				    "UTC-1100": -11 * 3600 * 1000,
				    "UTC-1200": -12 * 3600 * 1000,
				    "UTC+0000": 0 * 3600 * 1000,
				    "UTC+0100": 1 * 3600 * 1000,
				    "UTC+0200": 2 * 3600 * 1000,
				    "UTC+0300": 3 * 3600 * 1000,
				    "UTC+0400": 4 * 3600 * 1000,
				    "UTC+0500": 5 * 3600 * 1000,
				    "UTC+0600": 6 * 3600 * 1000,
				    "UTC+0700": 7 * 3600 * 1000,
				    "UTC+0800": 8 * 3600 * 1000,
				    "UTC+0900": 9 * 3600 * 1000,
				    "UTC+1000": 10 * 3600 * 1000,
				    "UTC+1100": 11 * 3600 * 1000,
				    "UTC+1200": 12 * 3600 * 1000
				};
				//如果参数返回false返回的显示字段
			    if (!_date_time){
					return "N/A";
					}
				//时区毫秒数
			    var office = UTC_ZONE[_zone];
			    var temp_date = null;
			    if (typeof _date_time == "string") {
					//如果参数是最初时间
			        if (_date_time == "1970-01-01 00:00:00"){
						 return "N/A";
					}
			        //如果参数是0000 
					if (_date_time == "0000-00-00 00:00:00"){
						 return "N/A";
					}
			        //如果参数是null  
			        if (_date_time == "null"){
						return "N/A";
					}
					if(_date_time == "N/A"){
						return "N/A";
					}
			        //如果字符串没有utc字符
			        if (_date_time.indexOf("UTC") < 0){
						_date_time += " UTC+0000";
						//将’-‘替换成’/‘兼容ie浏览器
						_date_time = _date_time.replace(/\-/g,'/')
						//将字符串转换成时间对象
						temp_date = new Date(_date_time);
					}
					 
				}else{//如果不是字符串
						temp_date = _date_time;
					}
				//返回正确格式的时间字符
			    function to_2_str(_value) {
			        if (_value < 10)
			            return "0" + _value;
			        else
			            return _value;
			    };
				// console.log(_date_time)
				// _date_time=_date_time.replace(/UTC(\-|\+)\d+$/g,'')
				// console.log(_date_time)
				//获取时区的毫秒数
				var temp = new Date(temp_date.getTime() + office);
				//获取带时区的时间
			    var date_str = temp.getUTCFullYear()
			        + "-"
			        + to_2_str(temp.getUTCMonth() + 1)
			        + "-"
			        + to_2_str(temp.getUTCDate())
			        + " "
			        + to_2_str(temp.getUTCHours())
			        + ":"
			        + to_2_str(temp.getUTCMinutes())
			        + ":"
			        + to_2_str(temp.getUTCSeconds())
					+ " " + _zone;
			    return date_str;
	},
    //捕获异步错误
	async_error(promise){
		return promise.then(res => res).catch(error => this.error_message(error));
	},
	//根据时区信息刷新列表时间
	refresh_time_zone(data,sle_zone){
		// console.log(data)
		data.forEach((item)=>{
			if('fld_server_open' in item){
				// if(item.fld_server_open){
				// 	// alert(0)
				// 	var reg=/UTC+(\-|\+)\d+$/g;
				// 	// var a;
				// 	item.fld_server_open=item.fld_server_open.replace(reg,'')
				// 	// console.log(item.fld_server_open)
				// }
				// console.log(reg,item.fld_server_open)
				item.fld_server_open=this.datetime2zone_x(item.fld_server_open,sle_zone)
			}
		})
	},
    //请求数据
    async get_data(sle_zone){
        this.timeOut=setTimeout(async function(){
            var time=60*1000;
            let res=await this.async_error(api.getServerInfo('/v1/sandbox/monitor/data'));
            this.list_data=res.data.data;
			this.refresh_time_zone(this.list_data,sle_zone);
            this.timeOut=setTimeout(this.get_data,time);
        }.bind(this),0);
    },  
    //根据屏幕的高度计算显示的页数
	count_page(){
		//计算显示框的高度
		this.offset_height=window.screen.height-280;
		//根据屏幕的高度计算显示的页数
		// this.data_page=parseInt(this.offset_height/43-1);
		// this.child_index_total=this.data_page;
	},
  }
}

</script>
<style scoped>
.thead {
		background-color: #ebecf0;
	    transform: translateY(0px);
		/* text-align: center; */
		/* z-index: 1; */
	}
    tr{
        height: 42px;
    }
.hello{
	margin-top: -2px;
}
td{
    overflow: hidden;
    text-overflow: ellipsis;
    /* padding: 0.75rem 0.9rem; */
    box-shadow: inset 1px 0 0 0 #dee2e6;
    border-bottom: 1px solid #dee2e6;
    padding-left: 10px!important;
    padding-right: 10px!important;
}
.shop {
    padding: 0;
    margin: 0;
    margin-top: 53px;
}
.t-table {
	font-size: 12px;
	border: 1px solid #dee2e6
	/* float: right; */
	/* overflow: auto; */
	/* max-height: 753px; */
}
.thb{
	color:#095ee8
}
.table tr td,th{
	padding-left: 10px!important;
	padding-right: 10px!important;
	vertical-align:middle;
	box-shadow: inset 1px 0 0 0 #dee2e6;
	background-color: #ebecf0;	
}
</style>